import { render, staticRenderFns } from "./permissions-users.vue?vue&type=template&id=68ff0c90&scoped=true"
import script from "./permissions-users.vue?vue&type=script&lang=js"
export * from "./permissions-users.vue?vue&type=script&lang=js"
import style0 from "./permissions-users.vue?vue&type=style&index=0&id=68ff0c90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ff0c90",
  null
  
)

export default component.exports